import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import merge from 'lodash/merge';
export default {
  name: 'CoreCodemirror',
  components: {
    codemirror
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    defaultCmOptions() {
      return {
        tabSize: 4,
        firstLineNumber: 1,
        mode: {
          name: 'javascript',
          json: true
        },
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: false,
        lineWrapping: false,
        hintOptions: {
          completeSingle: false
        }
      };
    },
    fullCmOptions() {
      return merge(this.defaultCmOptions, this.$attrs.options);
    },
    codemirror() {
      return this.$refs.codemirror.codemirror;
    }
  }
};